const companyName = "WAPPS";

export {companyName}; 